<div [ngStyle]="getBackground()" [ngClass]="getBackgroundWidth()"></div>
<div class="section" [ngClass]="getSectionStyling()">
    <p-carousel [value]="carouselSectionConfiguration.Containers" [autoplayInterval]="carouselSectionConfiguration.AutoScrollInterval * 1000" [circular]="true">
        <ng-template let-container pTemplate="item">
            <fw-container [containerConfiguration]="container"
                          [FormEditStyle]="FormEditStyle"></fw-container>
        </ng-template>
    </p-carousel>
</div>
